<script>
    import { onMount } from "svelte";

    import {
        BackArrow,
    } from "../../../Components/Common/index.svelte";

    import { isMobile } from "../../../stores";

    export let personalDetails = {};
    export let updatePhase = () => {};

    let canvas,
        ctx,
        isDrawing = false,
        hasSigned = false,
        isUpdatingOnboardingForm = false;

    $: isSubmitBtnDisabled = !hasSigned || isUpdatingOnboardingForm;

    onMount(() => {
        _setUpCanvas();

        if (personalDetails.signatureContent) _renderCanvasImg();
    });

    const completeOnboarding = async () => {
        const signatureData = canvas.toDataURL();

        personalDetails.signatureContent = signatureData;

        isUpdatingOnboardingForm = true;

        updatePhase(8);

        isUpdatingOnboardingForm = false;
    };

    const clearCanvas = () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        hasSigned = false;
    };

    // HELPER FUNCTIONS
    const _setUpCanvas = () => {
        canvas = document.getElementById("signature-canvas");
        ctx = canvas.getContext("2d");

        const startDrawAction = $isMobile ? "touchstart" : "mousedown";
        const drawAction = $isMobile ? "touchmove" : "mousemove";
        const stopDrawAction = $isMobile ? "touchend" : "mouseup";

        canvas.addEventListener(startDrawAction, _startDrawing);
        canvas.addEventListener(drawAction, _draw);
        canvas.addEventListener(stopDrawAction, _stopDrawing);
        canvas.addEventListener("mouseout", _stopDrawing);
    };

    const _renderCanvasImg = () => {
        const ctx = canvas.getContext("2d");
        const img = new Image();

        img.src = personalDetails.signatureContent;

        img.onload = () => ctx.drawImage(img, 0, 0);

        hasSigned = true;
    };

    const _startDrawing = (e) => {
        e.preventDefault();

        isDrawing = true;
        hasSigned = true;

        ctx.beginPath();

        if ($isMobile) {
            const touch = e.touches[0];
            const x = touch.clientX - canvas.offsetLeft;
            const y = touch.clientY - canvas.offsetTop;

            ctx.moveTo(x, y);
        } else
            ctx.moveTo(
                e.clientX - canvas.offsetLeft,
                e.clientY - canvas.offsetTop
            );
    };

    const _draw = (e) => {
        if (!isDrawing) return;

        e.preventDefault();

        if ($isMobile) {
            const touch = e.touches[0];
            const x = touch.clientX - canvas.offsetLeft;
            const y = touch.clientY - canvas.offsetTop;

            ctx.lineTo(x, y);
        } else
            ctx.lineTo(
                e.clientX - canvas.offsetLeft,
                e.clientY - canvas.offsetTop
            );

        ctx.stroke();
    };

    const _stopDrawing = () => {
        isDrawing = false;
    };




</script>

<div class="flex w-full gap-x-4 items-center justify-start">
    <BackArrow backFunc={() => updatePhase(6)} />
    <p class="text-[32px] font-bold text-primary">Complete Your Profile</p>
</div>

<p class="text-[20px] font-bold w-full">We are almost there!</p>

<p class="text-[16px] w-full">
    Please provide your signature below. Your signature will only be used for
    onboarding purposes and will never be used without your consent. By signing,
    you provide consent for Anaemate to sign you up to private health funds and
    other payers and agree that all information provided is correct to the best
    of your knowledge.
</p>

<canvas
    id="signature-canvas"
    width={$isMobile ? "300" : "400"}
    height={$isMobile ? "150" : "200"}
    bind:this={canvas}
/>

<button
    class={`btn btn-md btn-secondary w-full text-[16px] ${
        isUpdatingOnboardingForm ? "loading" : ""
    }`}
    on:click={completeOnboarding}
    disabled={isSubmitBtnDisabled}
>
    Complete onboarding
</button>
<button
    class="font-bold text-primary text-[20px]"
    on:click|preventDefault={clearCanvas}
>
    Clear
</button>

<style>
    canvas {
        border: 1px solid #ccc;
    }
</style>
